import { render, staticRenderFns } from "./FoodReceiptListTable.vue?vue&type=template&id=561fc2ae&scoped=true"
import script from "./FoodReceiptListTable.vue?vue&type=script&lang=js"
export * from "./FoodReceiptListTable.vue?vue&type=script&lang=js"
import style0 from "./FoodReceiptListTable.vue?vue&type=style&index=0&id=561fc2ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561fc2ae",
  null
  
)

export default component.exports